import React from 'react';
import CheckmarkFilled from '@shared/assets/icons/checkmark/filled.svg';
import { View } from '@shared/components/View';
import { ButtonWeb } from '@shared/components/button';
import { getTestId } from '@shared/util/getTestId';
import classNames from './ReactionPicker.module.css';
import { MBReaction, reactions } from './types';

export interface ReactionPickerProps {
  // Callback for when pressing a reaction
  onToggleReaction: (reaction: MBAPI.ReactionType, add: boolean) => void;

  // List of selected reaction types. Eg the reactions the user has already reacted with
  selected: MBAPI.ReactionType[];

  testID?: string;
}

/*
    This component lets the user pick a reaction. This is shown in a tooltip
    form when a reaction button is pressed.
*/
export function ReactionPicker({ onToggleReaction, selected, testID }: ReactionPickerProps) {
  return (
    <View className={classNames.reactionPicker} testID={testID}>
      {reactions.map(reaction => (
        <ReactionPickerItem
          key={reaction.type}
          isSelected={selected.includes(reaction.type)}
          reaction={reaction}
          onToggleReaction={onToggleReaction}
        />
      ))}
    </View>
  );
}

interface ReactionPickerItemProps extends Pick<ReactionPickerProps, 'onToggleReaction'> {
  isSelected: boolean;
  reaction: MBReaction;
}

function ReactionPickerItem({ reaction, onToggleReaction, isSelected }: ReactionPickerItemProps) {
  const onPress = () => onToggleReaction(reaction.type, !isSelected);
  const testID = getTestId('reaction-picker-item', reaction.emoji);

  return (
    <ButtonWeb onClick={onPress} testID={testID} className={classNames.item}>
      {reaction.emoji}
      {isSelected && (
        <div className={classNames.selectedIcon}>
          <CheckmarkFilled />
        </div>
      )}
    </ButtonWeb>
  );
}
